import { t } from '@ankr.com/common';

import { InitSliceListenersParams } from 'store/queries/types';
import { NotificationActions } from 'domains/notifications/store/NotificationActions';

import { isAuthRejectedAction } from '../utils/isAuthRejectedAction';
import { signOut } from '../actions/signOut';

const { showNotification } = NotificationActions;

export const initAuthListeners = ({
  listenerMiddleware,
}: InitSliceListenersParams) => {
  listenerMiddleware.startListening({
    matcher: isAuthRejectedAction,
    effect: async (_action, { dispatch, unsubscribe }) => {
      unsubscribe();

      dispatch(signOut.initiate());

      dispatch(
        showNotification({
          message: t('error.expired-session'),
          severity: 'error',
        }),
      );
    },
  });
};
